// extracted by mini-css-extract-plugin
module.exports = {"container":"dd31006766--container--1MHAD","slide":"dd31006766--slide--1dhvf"};